module.exports = __webpack_public_path__ + "img/character-1.fc685251.webp";